var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.editEntity()}}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'pencil']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }